<template>
    <v-container v-show="loadingWasSuccessful" class="pa-0">
        <div v-if="item" :id="customId">
            <div v-if="hasStepMedia" class="spot-media">
                <EspMediaSlider
                    :value="galleryImages"
                    @click="onImageClick"
                    @videoActivate="onVideoActivate"
                    :defaultValue="taskPlaceholderImage"
                />
                <EspTaskAudioButton v-if="stepAudioSrc" />
            </div>
            <!-- TODO default after answers einbauen -->
            <div class="pa-0 pa-sm-3 pa-md-5 pa-lg-10">
                <!-- SOLUTION ICON -->
                <div v-if="showAAC && !hasError" class="text-center">
                    <v-icon
                        v-if="spotIsSolved(item) || spotIsFailed(item)"
                        :color="taskOverlayColor(item, 1)"
                        style="font-size: 100px"
                        class="pt-2"
                    >{{ taskStatusIcon(item) }}</v-icon
                    >
                </div>

                <!-- Error Message -->
                <div v-if="hasError" class="pb-4 mt-n12">
                    <EspError>{{ $t(errorText, { taskname: this.labelTask }) }}</EspError>
                    <div v-if="hasCantPlayAgainError" class="text-center pt-4">
                        <v-btn
                            large
                            depressed
                            rounded
                            class="white--text"
                            :color="theme.btnColorPrimary"
                            @click="$emit('reloadList')"
                        >
                            {{ $t('ok')}}
                            <v-icon>mdi-sync</v-icon></v-btn
                        >
                    </div>
                </div>

                <!-- Text -->
                <div
                    v-if="!hasError"
                    class="px-3 px-sm-0 py-4 text-sm-h6 grey--text text--darken-3"
                    :style="whiteLabelFontStyle"
                >
                    <span :style="{'color':theme.textColor}" v-html="text"></span>
                </div>

                <!-- Task types -->
                <div v-if="showTask && !hasError && !isSolutionTypeTextQr(item)" class="py-4">
                    <EspSolutionTypeText
                        v-if="isSolutionTypeText(item)"
                        :spot="item"
                        @input="onTaskInput"
                        :placeholder="$t('taskSolution')"
                    />
                    <EspSolutionTypeText
                        v-if="isSolutionTypeTextOpen(item)"
                        :spot="item"
                        @input="onTaskInput"
                        :rows="5"
                        :placeholder="$t('taskSolution')"
                    />
                    <EspSolutionTypeMc
                        v-if="isSolutionTypeMc(item)"
                        :spot="item"
                        @input="onTaskInput"
                    />
                    <EspSolutionTypeMc
                        v-if="isSolutionTypeMcOpen(item)"
                        :spot="item"
                        @input="onTaskInput"
                    />
                    <EspSolutionTypeVideo
                        v-if="isSolutionTypeVideo(item)"
                        :eventId="selectedEventId"
                        :userId="userId"
                        :teamId="teamId"
                        :spot="item"
                        @input="onTaskInput"
                    />
                    <EspSolutionTypePhoto
                        v-if="isSolutionTypePhoto(item)"
                        :eventId="selectedEventId"
                        :userId="userId"
                        :teamId="teamId"
                        :spot="item"
                        @input="onTaskInput"
                    />
                    <EspSolutionTypeJsTask
                        v-if="isSolutionTypeJsTask(item)"
                        :spot="item"
                        @input="onTaskInput"
                    />
                    <EspVotingStar
                        v-if=" isSolutionTypeVoting(item) && isSolutionSubType(item, this._Config.VOTING_TYPE_STARS)"
                        :spot="item"
                        @input="onTaskInput"
                    />
                    <EspVotingThumb
                        v-if=" isSolutionTypeVoting(item) && isSolutionSubType(item,this._Config.VOTING_TYPE_THUMBS)"
                        :spot="item"
                        @input="onTaskInput"
                    />
                    <EspVotingSmile v-if="isSolutionTypeVoting(item) && isSolutionSubType(item, this._Config.VOTING_TYPE_SMILEYS)" :spot="item"  @input="onTaskInput"/>
                    <EspVotingMc v-if="isSolutionTypeVoting(item) && isSolutionSubType(item, this._Config.VOTING_TYPE_MC)" :spot="item"  @input="onTaskInput"/>
                    <EspVotingText v-if="isSolutionTypeVoting(item) && isSolutionSubType(item, this._Config.VOTING_TYPE_OPEN)" :spot="item"  @input="onTaskInput" :placeholder="$t('taskSolution')" />
                </div>
            </div>
        </div>
        <EspError v-else />
    </v-container>
</template>

<script>
import CONFIG from "../../constants/config";
import Utils from "../../store/modules/base";
import {settingsMixin} from "../../utils/settings-mixin";
import {spotMixin} from "../../utils/spot-mixin";
import {solutionMixin} from "../../utils/solution-mixin";
import {eventMixin} from "../../utils/event-mixin";
import {layoutMixin} from "../../utils/layout-mixin";
import {imageMixin} from "../../utils/image-mixin";
import EspSolutionTypeText from "../spots/EspSolutionTypeText";
import EspSolutionTypeVideo from "../spots/EspSolutionTypeVideo";
import EspSolutionTypePhoto from "../spots/EspSolutionTypePhoto";
import EspSolutionTypeMc from "../spots/EspSolutionTypeMc";
import EspSolutionTypeJsTask from "../spots/EspSolutionTypeJsTask";
import EspVotingStar from "../spots/EspVotingStar";
import EspVotingThumb from "../spots/EspVotingThumb";
import EspVotingSmile from "../spots/EspVotingSmile";
import EspVotingMc from "../spots/EspVotingMc";
import EspVotingText from "../spots/EspVotingText";
import EspError from "../animation/EspError";
import EspMediaSlider from '../ui/EspMediaSlider.vue';
import EspTaskAudioButton from '../spots/EspTaskAudioButton.vue';

export default {
    mixins: [settingsMixin, eventMixin, layoutMixin, spotMixin, solutionMixin, imageMixin],
    components: {
        EspError,
        EspSolutionTypeText,
        EspSolutionTypeVideo,
        EspSolutionTypeMc,
        EspSolutionTypePhoto,
        EspVotingStar,
        EspVotingThumb,
        EspVotingSmile,
        EspVotingMc,
        EspVotingText,
        EspSolutionTypeJsTask,
        EspMediaSlider,
        EspTaskAudioButton
    },
    props: {
        spot: {},
        wizardStep: {
            type: Number,
            default: 0,
        },
        inset: {
            type: Boolean,
            default: false,
        },
        // false while the details are hidden (keep-alive page inactive, answer animation): audio pauses
        active: {
            type: Boolean,
            default: true,
        },
        error: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        item: null,
        customId: '',
        _Config:null,
        prevText: null, // to only scroll back if updated
    }),
    mounted(){
    },
    watch: {
        // not deep: item is the same reactive object, and a nested change (distance on every GPS
        // fix) must not re-emit select, which cuts the running answer animation short
        spot: {
            handler(val) {
                this.item = val;
                this.$emit('select', val);
            },
            immediate: true,
        },
        text(newVal) {
            if (newVal && newVal !== this.prevText) {
                this.prevText = newVal;
                this.$nextTick(() => {
                    this.scrollToTopOfView(this.customId);
                });
            }
        },
        // not deep: the store diffs src/step/active itself, a new object per recompute is fine
        audioState: {
            handler(val) {
                this.$store.dispatch('taskaudio/sync', val);
            },
            immediate: true,
        },
    },
    computed: {
        hasCantPlayAgainError() {
            return (
                !this._.isEmpty(this.error) && this.error.error == 'cant_play_again'
            );
        },
        loadingWasSuccessful() {
            return !this.isLoadingSpot;
        },
        checkinText() {
            if (this.item) {
                return this.item.raetsel ? this.item.raetsel.radescr : this.item.wptxt;
            }
            return '';
        },
        taskText() {
            if (this.item) {
                return this.item.raetsel ? this.item.raetsel.ratask : this.item.wptxt;
            }
            return '';
        },
        text() {
            let text = this.showIntro
                ? this.checkinText
                : this.showTask
                    ? this.taskText
                    : this.afterAnswerComments;
            text = Utils.replaceKeywords(text, this.getOfflineStatistic, this.allSpots, this.keywordExtras)
            if (this.isSecretSpot(this.item) && text.length <= 0) {
                text = this.item.wphead;
            }
            return text;
        },
        afterAnswerComments() {
            if (this.item && this.item.raetsel) {
                if (this.isSolved) {
                    return !this._.isEmpty(this.item.raetsel.after_answer_comment_correct)
                        ? this.item.raetsel.after_answer_comment_correct
                        : ( this.isSolutionTypeVoting(this.item) ? this.$t('solveCorrectVoting') : this.$t('solveCorrectSolution') );
                } else if (this.isFailed) {
                    return !this._.isEmpty(this.item.raetsel.after_answer_comment_wrong)
                        ? this.item.raetsel.after_answer_comment_wrong
                        : this.$t('solveWrongSolution');
                }
            }

            if (
                !this._.isEmpty(this.item) &&
                this.isInfoSpot(this.item) &&
                this._.isEmpty(this.item.after_answer)
            ) {
                return this.checkinText;
            }

            return !this._.isEmpty(this.item) ? this.item.after_answer : null;
        },
        galleryImages() {
            return this.getGalleryImages(this.item, this.wizardStep, this.isSolved);
        },
        hasStepMedia() {
            return !this._.isEmpty(this.galleryImages) || !!this.stepAudioSrc;
        },
        // same placeholder as the spot list tiles, for a step with audio but no image
        taskPlaceholderImage() {
            return this.selectedEvent && this.selectedEvent.bg_task
                ? this.getEventDefaultTaskImage(this.selectedEvent.bg_task)
                : this.defaultImage;
        },
        stepAudioSrc() {
            return this.item && !this.hasError
                ? this.getStepAudio(this.item, this.wizardStep, this.isSolved)
                : null;
        },
        // TODO: autoplay is hard-wired like in the native apps (iOS EspotoTaskVC has the same TODO);
        // evaluate the server parameter here once task audio delivers one.
        autoplayStepAudio() {
            return !this.isInactive;
        },
        audioState() {
            return {
                src: this.stepAudioSrc,
                step: this.wizardStep,
                active: this.active,
                autoplay: this.autoplayStepAudio,
            };
        },
        isCheckedIn() {
            return this.spotIsCheckedIn(this.item);
        },
        isSolved() {
            return this.spotIsSolved(this.item);
        },
        isFailed() {
            return this.spotIsFailed(this.item);
        },
        isInactive() {
            return this.spotIsInactive(this.item);
        },
        showIntro() {
            return this.wizardStep == CONFIG.TASK_STEPPER_CHECKIN;
        },
        showTask() {
            return this.wizardStep == CONFIG.TASK_STEPPER_TASK;
        },
        showAAC() {
            return this.wizardStep == CONFIG.TASK_STEPPER_AAC;
        },
        hasError() {
            return !this._.isEmpty(this.error);
        },
        errorText() {
            return this.hasError ? this.error.error : null;
        },
    },
    methods: {
        onImageClick(index) {
            console.log(index);
        },
        // a video in the lightbox silences the step audio; it does not come back on its own (like native)
        onVideoActivate() {
            if (this.$store.getters['taskaudio/playing']) {
                this.$store.dispatch('taskaudio/toggle');
            }
        },
        onTaskInput(val, serverData) {
            this.$emit('input', val, serverData);
        },
    },
    created() {
        this.customId = `spotDetails_${new Date().getTime()}`;
        this._Config = CONFIG;
    },
    beforeDestroy() {
        // destroyed on close, but also on every refreshView remount (teammate solve), so only pause;
        // the real stop runs from the close handler in EventLayout and the route watcher in TasksPage
        this.$store.dispatch('taskaudio/suspend');
    },
};
</script>

<style scoped>
.spot-media {
    position: relative;
}
</style>
